import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {SliceNames} from "../constants";
import {IClient, IClientState, IClientWishTicketsResponse, initialClient} from "./Helper";
import {
    createClient,
    disableClientUser,
    getClient,
    getClients,
    getClientWishTickets,
    updateClient,
    updateVoucherComment
} from "./ActionCreators";
import {ICreateClientUser} from "../../api/clientService";
import {initialLoggedInUserState} from "../auth/Helper";

const initialValue: IClientState = {
    items: [],
    selectedClient: initialClient,
    fetchClientLoading: false,
    fetchClientsLoading: false,
    clientActionLoading: false,
    clientWishTicketsLoading: false,
    clientWishTickets: {
        count: 0,
        total_pages: 0,
        data: []
    },
    disableClientUserLoading: false
}


const clientSlice = createSlice({
    name: SliceNames.CLIENT,
    initialState: initialValue,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(
            getClients.pending, (state) => {
                state.fetchClientsLoading = true
            })
            .addCase(
                getClients.fulfilled, (state, action: PayloadAction<IClient[]>) => {
                    state.items = action.payload
                    state.fetchClientsLoading = false
                })
            .addCase(
                getClients.rejected, (state) => {
                    state.fetchClientsLoading = false
                })
            .addCase(
                getClient.pending, (state) => {
                    state.fetchClientLoading = true
                })
            .addCase(
                getClient.fulfilled, (state, action: PayloadAction<IClient>) => {
                    state.selectedClient = action.payload
                    state.fetchClientLoading = false
                })
            .addCase(
                getClient.rejected, (state) => {
                    state.fetchClientLoading = false
                })
            .addCase(
                createClient.pending, (state) => {
                    state.clientActionLoading = true
                })
            .addCase(
                createClient.fulfilled, (state, action: PayloadAction<{
                    data: IClient,
                    users: ICreateClientUser[]
                }>) => {
                    state.items = [...state.items, {
                        ...action.payload.data,
                        users: action.payload.users.map(u => ({...initialLoggedInUserState, ...u}))
                    }]
                    state.clientActionLoading = false
                })
            .addCase(
                createClient.rejected, (state) => {
                    state.clientActionLoading = false
                })
            .addCase(
                updateClient.pending, (state) => {
                    state.clientActionLoading = true
                })
            .addCase(
                updateClient.fulfilled, (state, action: PayloadAction<{
                    data: IClient,
                    users: ICreateClientUser[]
                }>) => {
                    state.items = [
                        ...state.items.map(el => (el.id === action.payload.data.id ? {
                            ...el, ...action.payload.data,
                            users: [...el.users, ...action.payload.users.map(u => ({...initialLoggedInUserState, ...u}))]
                        } : el))
                    ]
                    state.clientActionLoading = false
                })
            .addCase(
                getClientWishTickets.pending, (state) => {
                    state.clientWishTicketsLoading = true
                })
            .addCase(
                getClientWishTickets.fulfilled, (state, action: PayloadAction<IClientWishTicketsResponse>) => {
                    state.clientWishTickets = action.payload
                    state.clientWishTicketsLoading = false
                })
            .addCase(
                getClientWishTickets.rejected, (state) => {
                    state.clientWishTicketsLoading = false
                })
            .addCase(
                updateVoucherComment.fulfilled, (state, action: PayloadAction<{
                    code: string,
                    comment: string
                }>) => {
                    state.clientWishTickets.data = state.clientWishTickets.data.map(t => {
                        if (t.code === action.payload.code) {
                            return {...t, comment: action.payload.comment}
                        }
                        return t
                    })
                }
            )
            .addCase(
                disableClientUser.pending, (state) => {
                    state.disableClientUserLoading = true
                })
            .addCase(
                disableClientUser.fulfilled, (state, action: PayloadAction<{
                    userId: string,
                    clientId: string
                }>) => {
                    state.items = state.items.map(client => {
                        if (client.id !== action.payload.clientId) {
                            return client
                        }

                        return {
                            ...client,
                            users: client.users.filter(user => user.id !== action.payload.userId)
                        }
                    })
                    state.disableClientUserLoading = false
                })
            .addCase(
                disableClientUser.rejected, (state) => {
                    state.disableClientUserLoading = false
                })
    }
})

export default clientSlice.reducer

